import { FCM } from '@capacitor-community/fcm'
import { useAuthStore } from "@/store/auth";
import { mutation } from "@/graphql/client";
import { gql } from "@urql/vue";
import { isPlatform } from '@ionic/vue';
import {Capacitor} from "@capacitor/core";
import {getVersion} from "@/helper/version";
import {graphql} from "@/graphql/generated";


export const deviceProfileRefresh = async (silent = false) => {
    if(isAvailable()){
        const authStore = useAuthStore()

        let currentlyValidDeviceToken
        try {
            currentlyValidDeviceToken = (await FCM.getToken()).token
            // if (refreshInstantly) {
            //     currentlyValidDeviceToken = (await FCM.refreshToken()).token
            // }
        } catch (e) {
            currentlyValidDeviceToken = 'FCM.getToken error'
            // console.error(e)
        }
        const localStorageToken = authStore.getFCMToken()
        const devicePlatform = getDevicePlatform() || ''

        authStore.setFCMToken(currentlyValidDeviceToken)

        const appVersion = await getVersion()

        await setDeviceProfile(currentlyValidDeviceToken, devicePlatform, localStorageToken, appVersion, silent)
    }
}

const isAvailable = () => Capacitor.isPluginAvailable('FCM') && getDevicePlatform() !== undefined /* && Capacitor.isNativePlatform() */

const setDeviceProfile = async (newToken: string, platform: string, oldToken: string|undefined, appVersion: string | undefined, silent = false) => {
    const MUTATION = graphql(`
        mutation SetDeviceProfile(
            $newFirebaseCloudMessagingRegistrationToken: String!
            $oldFirebaseCloudMessagingRegistrationToken: String
            $platform: String!
            $appVersion: String
        ) {
            setDeviceProfile(
                newDeviceProfile: {
                    firebaseCloudMessagingRegistrationToken: $newFirebaseCloudMessagingRegistrationToken
                    platform: $platform,
                    appVersion: $appVersion,
                }
                oldFirebaseCloudMessagingRegistrationToken: $oldFirebaseCloudMessagingRegistrationToken
            ) {
                firebaseCloudMessagingRegistrationToken
                platform,
                appVersion
            }
        }
    `);

    const result = await mutation(MUTATION, {
        oldFirebaseCloudMessagingRegistrationToken: oldToken,
        newFirebaseCloudMessagingRegistrationToken: newToken,
        platform: platform,
        appVersion: appVersion,
    }, silent);

    const success = result?.data;

    if (!success) {
        throw new Error("error while storing device profile");
    }
};

export const getDevicePlatform = (): string | undefined => {
    if (isPlatform('ios')) {
        return 'ios'
    }

    if (isPlatform('android')) {
        return 'android'
    }

    return undefined
};
